<template>
  <!-- confirm START -->
  <transition name="fade" mode="out-in">
    <div class="dialog dialog-confirm" v-if="loadingVisible">
      <div class="dialog-confirm-container">

        <div class="inner inner-product-choices">
          <div class="icon" v-if="false"></div>
          <h4 v-html="headline"></h4>
          <div class="excerpt" v-html="excerpt"></div>

          <div class="product-choices">
            <el-radio
              class="product-choices-item"
              v-for="(prod, prodIndex) in data"
              v-model="selectedOptionChild"
              :key="`${prod.ean} - ${prod.name}`"
              :label="`${prod.ean}`"
            >
              <span class="productSVG" v-if="prodIndex === 0">
                <svg data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 214 513"><defs><clipPath id="a"><path d="M0 0h214v513H0z" stroke-width="0" fill="none"/></clipPath></defs><g clip-path="url(#a)"><path d="M58.62 1.7c-5.4 3.4-6.3 10.6-2.2 16.6l2.5 3.8-2.5 3c-3.7 4.4-3.6 10.1.3 14 1.6 1.6 3.7 2.9 4.5 2.9.9 0 1.6.3 1.6.7-.1.5-4.2 33.9-9.3 74.3l-9.3 73.5-11 11c-17.1 17-25.1 30.9-30.6 53.5-2.1 8.3-2.2 10.9-2.5 110.2-.3 63.1 0 104.4.6 108.8 2.6 18.7 16.3 33.7 34 37 7.2 1.4 137 1.4 144.2 0 17.7-3.3 31.4-18.3 34-37 .6-4.4.9-45.7.6-108.8-.3-99.3-.4-101.9-2.5-110.2-5.5-22.6-13.5-36.5-30.6-53.5l-11-11-9.3-73.5c-5.1-40.4-9.2-73.8-9.3-74.3 0-.4.7-.7 1.6-.7.8 0 2.9-1.3 4.5-2.9 3.9-3.9 4-9.6.3-14l-2.5-3 2.5-3.8c4.2-6.1 3.1-13.4-2.4-16.6-2.5-1.5-7.6-1.7-48.2-1.7-40.4.1-45.6.2-48 1.7Zm79.2 108.3c4.6 36.8 8.1 67.2 7.8 67.5-.2.3-3.1-.4-6.4-1.5-3.2-1.2-9.7-2.7-14.3-3.5-15.9-2.8-36.4-1.4-50.5 3.5-3.3 1.1-6.2 1.8-6.4 1.5-.3-.3 3.2-30.7 7.8-67.5l8.4-67h45.2l8.4 67Zm-7.5 85.5c23.4 6.8 42.4 22.9 53 44.8 8.6 17.9 8 8.4 8 129.4v107.1l-3 4.4c-1.7 2.3-5.1 5.4-7.5 6.8l-4.5 2.5h-139l-4.5-2.5c-2.4-1.4-5.8-4.5-7.5-6.8l-3-4.4V369.7c0-121-.6-111.5 8-129.4 12.1-25 35-42.2 63.2-47.3 8.9-1.6 26.9-.4 36.8 2.5Zm0 0"/></g><path d="M102.02 236.5c-2.5 1.1-3.9 2.8-5.7 7-7.3 16.4-8.2 26.2-3.2 32.9 1.5 1.9 2.7 4.8 2.7 6.4v3l-9.8-4.4c-11.2-5-14.2-5.1-18.7-.4-4.4 4.6-3.9 8.6 2.5 21.4 7.1 14.3 10.4 17.1 19.6 17.1h6.4v9.1l-8.2-3.9c-4.5-2.1-9.6-4.1-11.4-4.4-6.7-1.1-13.3 5.9-11.8 12.5.4 1.5 2.9 7.3 5.6 13 5.4 11.2 8.9 14.8 15.6 16.3 2.3.5 5.2.5 7.1-.1l3.1-.9v5c0 2.7-.2 4.9-.4 4.9s-4.2-1.8-8.9-4c-4.8-2.3-10-4-12-4-4.3 0-8.2 3-9.7 7.4-1.2 3.9.3 8.6 7.2 21.9 5.2 10 9.9 13.2 18.3 12.5l5.3-.5.4 18.1c.3 15.6.6 18.5 2.1 20.8 3.9 5.8 13.5 5.8 17.4 0 1.5-2.3 1.8-5.2 2.1-20.8l.4-18.1 5.2.5c8.8.7 13.4-2.7 19.2-14.1 6.3-12.4 7.6-16.5 6.4-20.3-1.5-4.4-5.4-7.4-9.7-7.4-2 0-7.2 1.7-12 4-4.7 2.2-8.7 4-8.9 4s-.4-2.2-.4-4.9v-5l3.1.9c4.2 1.2 10.1-.2 14.2-3.3 3.2-2.4 11-16.6 13.6-24.9 2.4-7.3-3.9-14.7-11.3-13.5-1.8.3-6.9 2.3-11.4 4.4l-8.2 3.9v-9.1h6.4c9.2 0 12.5-2.8 19.6-17.1 6.4-12.8 6.9-16.8 2.5-21.4-4.6-4.8-7.2-4.7-18.5.3l-10 4.5v-3c0-1.6 1.2-4.5 2.7-6.4 5-6.7 4.1-16.5-3.2-32.9-1.9-4.4-3.2-5.9-5.9-7-4.3-1.8-5.2-1.8-9.4 0Zm0 0" fill="#1f66b0"/></svg>
              </span>
              <span class="productSVG" v-else>
                <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 470"><defs/><path class="cls-2" d="M506 236.14c-1.6-.8-5.5-1.5-8.8-1.5h-5.9l-.7-10.9c-1.1-19.1-6.7-34.5-17.1-47.1-2.5-3-4.8-6.4-5-7.5-.8-3.6-18.5-126.8-18.3-126.9 4.5-2.2 5.8-3.2 6.9-5.2 1.9-3.6 1.5-8.1-1-11.4l-2.1-3 2.1-4.2c3.7-7.2 2.5-14.1-2.9-16.9-3.7-2-70.7-2-74.4 0-5.4 2.8-6.6 9.7-2.9 16.9l2.1 4.2-2.1 3c-3.9 5.2-2.3 12.8 3.3 15.2 1.5.7 2.8 2.1 2.8 3 0 5.5-18.2 126.4-19.2 127.8-.7 1-3.3 4.1-5.6 7.1-9.6 11.7-14.7 26.3-15.8 45l-.7 10.9h-9.4l-.7-10.9c-1.1-19.1-6.7-34.5-17.1-47.1-2.5-3-4.8-6.4-5-7.5-.8-3.6-18.5-126.8-18.3-126.9 4.5-2.2 5.8-3.2 6.9-5.2 1.9-3.6 1.5-8.1-1-11.4l-2.1-3 2.1-4.2c3.7-7.2 2.5-14.1-2.9-16.9-3.7-2-70.7-2-74.4 0-5.4 2.8-6.6 9.7-2.9 16.9l2.1 4.2-2.1 3c-3.9 5.2-2.3 12.8 3.3 15.2 1.5.7 2.8 2.1 2.8 3 0 5.5-18.2 126.4-19.2 127.8-.7 1-3.3 4.1-5.6 7.1-9.6 11.7-14.7 26.3-15.8 45l-.7 10.9h-9.4l-.7-10.9c-1.1-19.1-6.7-34.5-17.1-47.1-2.5-3-4.8-6.4-5-7.5-.8-3.6-18.5-126.8-18.3-126.9 4.5-2.2 5.8-3.2 6.9-5.2 1.9-3.6 1.5-8.1-1-11.4l-2.1-3 2.1-4.2c2.4-4.8 2.8-9.7 1-13-2.7-5.2-3.1-5.3-39.6-5.4-18.7-.1-35 0-36.2.3-2.9.6-7.3 5.1-7.5 7.7-.3 4.1.3 7 2.3 10.8l1.9 3.8-2.1 3c-3.9 5.2-2.3 12.8 3.3 15.2 1.5.7 2.8 2.1 2.8 3 0 5.5-18.2 126.4-19.2 127.8-.7 1-3.3 4.1-5.6 7.1-9.6 11.7-14.7 26.3-15.8 45l-.7 10.9h-5.9c-3.3 0-7.2.7-8.8 1.5-6.3 3.3-6-1.7-6 100.3 0 58.6.4 94.9 1 98.3 3.3 17.3 18.2 31.4 36.2 33.9 8.4 1.3 429.2 1.3 437.6 0 18-2.5 32.9-16.6 36.2-33.9.6-3.4 1-39.7 1-98.3 0-102 .3-97-6-100.3ZM403.6 45.34l.6-2.7h24.3l8.1 55.8c4.5 30.6 8 55.8 7.9 56-.2.2-3.6-.7-7.6-2-10.4-3.2-32.1-3.2-41.9 0-3.5 1.2-6.6 2-6.8 1.8-.3-.4 14.1-102.2 15.4-108.9Zm-40.6 180c0-5 .7-11.6 1.5-14.6 7.4-27.8 35.7-45.1 63.3-38.6 19.3 4.6 34.6 19.5 39.7 38.6.8 3 1.5 9.6 1.5 14.6v9.3H363v-9.3Zm-119.4-180 .6-2.7h24.3l8.1 55.8c4.5 30.6 8 55.8 7.9 56-.2.2-3.6-.7-7.6-2-10.4-3.2-32.1-3.2-41.9 0-3.5 1.2-6.6 2-6.8 1.8-.3-.4 14.1-102.2 15.4-108.9Zm-40.6 180c0-5 .7-11.6 1.5-14.6 7.4-27.8 35.7-45.1 63.3-38.6 19.3 4.6 34.6 19.5 39.7 38.6.8 3 1.5 9.6 1.5 14.6v9.3H203v-9.3Zm-119.4-180 .6-2.7h24.3l8.1 55.8c4.5 30.6 8 55.8 7.9 56-.2.2-3.6-.7-7.6-2-10.4-3.2-32.1-3.2-41.9 0-3.5 1.2-6.6 2-6.8 1.8-.3-.4 14.1-102.2 15.4-108.9Zm-40.6 180c0-5 .7-11.6 1.5-14.6 7.4-27.8 35.7-45.1 63.3-38.6 19.3 4.6 34.6 19.5 39.7 38.6.8 3 1.5 9.6 1.5 14.6v9.3H43v-9.3Zm447.5 118.8v88l-2.5 4.5c-1.4 2.4-4.5 5.8-6.8 7.5l-4.4 3H35.2l-4.4-3c-2.3-1.7-5.4-5.1-6.8-7.5l-2.5-4.5-.3-87c-.1-47.8 0-87.5.2-88.2.4-1.1 44-1.3 234.8-1.1l234.3.3v88Z"/><path stroke-width="0" fill="none" d="M0 0h513v470H0z"/><path class="cls-2" d="M194 278.54c-8.4 2.6-15.9 9-20.1 17.1-2 3.7-2.4 6-2.4 13.5 0 10.6 2 15.8 8.8 22.5 5.1 5.2 9.6 7.5 17.2 8.9 8 1.5 109 1.5 117 0 7.6-1.4 12.1-3.7 17.2-8.9 6.8-6.7 8.8-11.9 8.8-22.5 0-7.8-.4-9.7-2.7-14-3.1-6-8.7-11.4-14.8-14.6l-4.5-2.4-61-.2c-33.5-.1-62.1.2-63.5.6Zm120 21.6c6.6 3.4 7.6 12.1 1.9 16.9l-3.1 2.6H199.2l-3.1-2.6c-5.6-4.7-4.8-13.3 1.7-16.8 4.1-2.3 111.9-2.3 116.2-.1Zm0 0"/><path class="cls-3" d="M285.09 234.15c-.28-.4-.61-.8-1-1.2-3.35-3.5-5.24-3.42-13.48.22l-2.18.98h16.65ZM242.19 234.15l-2.03-.91c-8.16-3.64-10.35-3.71-13.63-.29-.38.4-.71.8-.99 1.2h16.65ZM247.3 234.15h16.04c.05-1.19.9-3.21 1.96-4.55 3.64-4.88 2.98-12.02-2.33-23.97-1.38-3.2-2.33-4.3-4.3-5.1-3.13-1.31-3.79-1.31-6.85 0-1.82.8-2.84 2.04-4.16 5.1-5.31 11.95-5.97 19.09-2.33 23.97 1.06 1.35 1.91 3.37 1.96 4.55ZM125.73 234.15c-.28-.4-.61-.8-1-1.2-3.35-3.5-5.24-3.42-13.48.22l-2.18.98h16.65ZM82.84 234.15l-2.03-.91c-8.16-3.64-10.35-3.71-13.63-.29-.38.4-.71.8-.99 1.2h16.65ZM87.94 234.15h16.04c.05-1.19.9-3.21 1.96-4.55 3.64-4.88 2.98-12.02-2.33-23.97-1.38-3.2-2.33-4.3-4.3-5.1-3.13-1.31-3.79-1.31-6.85 0-1.82.8-2.84 2.04-4.16 5.1-5.31 11.95-5.97 19.09-2.33 23.97 1.06 1.35 1.91 3.37 1.96 4.55ZM444.42 234.15c-.28-.4-.61-.8-1-1.2-3.35-3.5-5.24-3.42-13.48.22l-2.18.98h16.65ZM401.53 234.15l-2.03-.91c-8.16-3.64-10.35-3.71-13.63-.29-.38.4-.71.8-.99 1.2h16.65ZM406.63 234.15h16.04c.05-1.19.9-3.21 1.96-4.55 3.64-4.88 2.98-12.02-2.33-23.97-1.38-3.2-2.33-4.3-4.3-5.1-3.13-1.31-3.79-1.31-6.85 0-1.82.8-2.84 2.04-4.16 5.1-5.31 11.95-5.97 19.09-2.33 23.97 1.06 1.35 1.91 3.37 1.96 4.55Z"/></svg>
              </span>
              <span v-html="prod.name"></span>
            </el-radio>
          </div>

          <div class="dialog-footer centered">
            <div
              class="btn-inverted close"
              v-on:click="close()"
              v-on:touchstart="touchStart($event)"
              v-on:touchend="touchEnd($event);"
              v-on:touchcancel="touchEnd($event)"
              v-html="$t('terminal.index.cart.products.choices.abort')"
            ></div>
            <div
              :class="[
                'btn-default confirm btn-default-blue',
                { 'disabled' : !selectedOptionChild }
              ]"
              v-on:click="confirm(selectedOptionChild); selectedOptionChild = ''"
              v-on:touchstart="touchStart($event)"
              v-on:touchend="touchEnd($event);"
              v-on:touchcancel="touchEnd($event)"
              v-html="$t('terminal.index.cart.products.choices.select')"
            ></div>
          </div>

          <!-- cart:actions:checkout:abort START -->
          <div
            class="abort"
            v-if="false"
            v-on:click="resetStoreCart()"
          >
            <span v-html="$t('terminal.index.cart.purchase.abort')"></span>
          </div>
          <!-- cart:actions:checkout:abort END -->
        </div>
      </div>
    </div>
  </transition>
  <!-- confirm END -->
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'dialog-confirm',
  props: {
    data: {
      type: Array,
    },

    loadingVisible: {
      type: Boolean,
      default: false,
    },

    headline: {
      type: String,
    },

    excerpt: {
      type: String,
    },

    open: {
      type: Function,
    },

    close: {
      type: Function,
    },

    confirm: {
      type: Function,
    },

    selectedOption: {
      type: String,
    },
  },
  data() {
    return {
      selectedOptionChild: this.selectedOption,
    };
  },
  methods: {
    ...mapActions([
      'clearCart',
    ]),

    touchStart(event) {
      event.target.classList.add('pressed');
    },

    touchEnd(event) {
      event.target.classList.remove('pressed');
    },

    async resetStoreCart() {
      // reset store cart
      await this.clearCart();

      const formData = new FormData();
      /**
       * Locale
       */
      formData.append('locale', localStorage.getItem('boxLang'));
      // Logout data
      await this.$http.post(`${localStorage.getItem('anybox_terminal_api_url')}/logout`, formData, {
        headers: {
          'X-Api-Key': `${localStorage.getItem('anybox_terminal_api_key')}`,
          Authorization: `Bearer ${localStorage.getItem('auth')}`,
        },
      })
        .then((response) => {
          if (response.data) {
            // mutating to store for client rendering &
            // saving token in cookie for server rendering
            this.$store.commit('SET_AUTH', null);
            localStorage.removeItem('auth');

            // mutating to store for client rendering &
            // saving user data in cookie for server rendering
            this.$store.commit('SET_USER', null);
            localStorage.removeItem('user');

            // clear other important data
            localStorage.removeItem('qrcodeActive');
          }
        });

      // redirect to home + reload app
      window.location.assign('/');
    },
  },
};
</script>
